<div
  class="campaign-banner-container mx-auto flex flex-col"
  *ngIf="hasEnabledBanners$ | async">
  <div class="container-title">
    <h2 class="title mt-12 mb-6 lg:mt-16">
      {{ 'Promotions' }}
    </h2>
  </div>
  <div
    class="campaign-banners grid grid-cols-1 gap-x-8 gap-y-6 pb-14 lg:grid-cols-4">
    <ng-container *ngFor="let campaignBanner of campaignBanners$ | async">
      <div class="flex flex-col" *ngIf="showBanner(campaignBanner)">
        <img
          class="desktop-image rounded-md h-[150px]"
          [src]="campaignBanner.desktopImageUrl"
          alt="" />
        <img
          class="mobile-image rounded-md"
          [src]="campaignBanner.mobileImageUrl"
          alt="" />
        <h3
          class="main-content mt-4 mb-2"
          [innerHTML]="campaignBanner.mainContent"></h3>
        <p
          class="sub-content mt-4 flex-1"
          [innerHTML]="campaignBanner.subContent"></p>
        <p class="link mb-4" [innerHTML]="campaignBanner.link"></p>
      </div>
    </ng-container>
  </div>
</div>
